import toast from 'react-hot-toast';
import { TodoType } from '../api';

export const listEventListener = (
  todos: TodoType[],
  setTodos: (todos: TodoType[]) => void
) => {
  const onTodoAdded = (todo: TodoType) => {
    setTodos([...todos, todo]);
    toast('Todo Added', { icon: '📝' });
  };

  const onTodoChecked = (updatedTodo: TodoType) => {
    const oldTodos = todos.filter((t) => t.id !== updatedTodo.id);
    setTodos([...oldTodos, updatedTodo]);
    toast('Todo checked', { icon: '✅' });
  };

  const onTodoUnchecked = (updatedTodo: TodoType) => {
    const oldTodos = todos.filter((t) => t.id !== updatedTodo.id);
    setTodos([...oldTodos, updatedTodo]);
    toast('Todo Unchecked', { icon: '❌' });
  };

  const onNewConnection = (data: TodoType[]) => {
    toast('New Connection', { icon: '🌐' });
  };

  const onDisconnected = (data: TodoType[]) => {
    toast('Disconnected', { icon: '⚡' });
  };

  return {
    onTodoAdded,
    onTodoChecked,
    onTodoUnchecked,
    onNewConnection,
    onDisconnected,
  };
};

export const onClipboardClick = () => {
  navigator.clipboard.writeText(window.location.href);
  toast('Url copied to clipboard!', { icon: '📋' });
};
